import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Controller,
  FieldWrapper,
  getDuration,
  Label,
  RegularField,
  useFormContext,
  useResponsive,
} from '@common-fe/common-fe';
import _ from 'lodash';

import ResendCodeButton from '../../Verification/components/ResendCodeButton';

import { useEmailSendCodeQuery } from './queries';

interface Props {}
const LimitedAccessVerificationMethodForm: React.FC<Props> = () => {
  const { t } = useTranslation();
  const { isMobile } = useResponsive();
  const { handleReceiveCode } = useEmailSendCodeQuery();

  const {
    control,
    formState: { errors },
  } = useFormContext<{
    code: string;
  }>();

  const handleReceiveCodeDebounce = _.debounce(() => handleReceiveCode(), getDuration({ seconds: 1 }));
  useEffect(() => {
    handleReceiveCodeDebounce();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      <Box
        data-testid="limited-access-verification-email-form"
        pad={isMobile ? 'spacing8' : 'spacing24'}
        margin={{ top: isMobile ? 'spacing16' : 'spacing24' }}
        round="moduleRound"
        background="module"
      >
        <Box
          pad={isMobile ? 'spacing12' : 'spacing24'}
          round="container1Round"
          background="canvas"
          direction="column"
        >
          <FieldWrapper direction={isMobile ? 'column' : 'row'} align="start">
            <Label name="code" showRequireIcon isNarrow>
              {t('Verification code')}
            </Label>
            <Controller
              name="code"
              control={control}
              render={({ field }) => (
                <Box direction="column" fill width={{ max: 'medium' }} style={{ position: 'relative' }}>
                  <RegularField
                    testId="limited-access-verification-email-form_code"
                    editMode
                    placeholder={t('Verification code')}
                    value={field.value}
                    onChange={field.onChange}
                    name="code"
                    errorText={errors?.code?.message}
                  />
                  <Box margin={{ top: 'spacing12' }}>
                    <ResendCodeButton
                      testId="limited-access-verification-email-form_resend-code"
                      onResend={handleReceiveCodeDebounce}
                    />
                  </Box>
                </Box>
              )}
            />
          </FieldWrapper>
        </Box>
      </Box>
    </>
  );
};

export default React.memo(LimitedAccessVerificationMethodForm);
